// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getEquipmentItem } from '../../state/actions/EquipmentActions';
import { getProducts } from '../../state/actions/ProductActions';
import { uploadPlanogram } from '../../state/actions/PlanogramActions';
import { Loading } from '../../containers/Loading' ;
import { Button, FormGroup, FormText, Label } from 'reactstrap';
import { PlanogramProduct } from './PlanogramProduct';
import { PlanogramItem } from './PlanogramItem';
import { PlanogramDetailsModal } from '../../modals/PlanogramDetailsModal';
import Slider from 'rc-slider';


// COMPONENT
class PlanogramCreationPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            equipmentItem: {},
            shelfGroups: [],
            products: [],
            selectedProduct: {},
            selectedShelf: {},
            detailsModal: false,
            isValid: true,
            showSlider: false,
            sliderValue: 0,
            sliderMax: 5,
            sliderMin: 0
        };

        this.productSelected = this.productSelected.bind(this);
        this.deselectProduct = this.deselectProduct.bind(this);
        this.updateShelfGroups = this.updateShelfGroups.bind(this);
        this.uploadPlanogram = this.uploadPlanogram.bind(this);
        this.stripProductDetailsFromPlanogram = this.stripProductDetailsFromPlanogram.bind(this);
        this.toggleDetailsModal = this.toggleDetailsModal.bind(this);
        this.saveDetails = this.saveDetails.bind(this);
        this.availableSlotsUpdated = this.availableSlotsUpdated.bind(this);
        this.sliderSelectionChanged = this.sliderSelectionChanged.bind(this);
        this.shelfSelected = this.shelfSelected.bind(this);
        this.addProductsToShelf = this.addProductsToShelf.bind(this);
        this.updateShelf = this.updateShelf.bind(this);
    }

    componentDidMount(){
        this.props.getEquipmentItem(this.props.match.params.equipmentId);
        this.props.getProducts();
    }

    componentDidUpdate(prevProps){
        if(this.props.equipmentItem != prevProps.equipmentItem){
            this.setState({
                equipmentItem: this.props.equipmentItem,
                shelfGroups: this.props.equipmentItem['shelf-groups']
            });
        }

        if(this.props.products != prevProps.products){
            this.setState({products: this.props.products});
        }
    }

    availableSlotsUpdated(slots){
        this.setState({
            sliderMax: slots,
            sliderValue: 0
        });
    }

    sliderSelectionChanged(value){
        this.setState({sliderValue: value});
    }

    productSelected(product){
        if(product == this.state.selectedProduct){
            this.setState({
                selectedProduct: {}
            });
        } else {
            this.setState({selectedProduct: product});
            this.setState({
                sliderValue: 0,
                showSlider: false
            });
        }
    }

    shelfSelected(shelf){
        this.setState({
            selectedShelf: shelf,
            showSlider: shelf != {}
        });
    }

    deselectProduct(){
        this.setState({
            selectedProduct: {},
            showSlider: false,
            selectedShelf: {}
        });
    }

    updateShelfGroups(shelfGroups){
        this.setState({shelfGroups: shelfGroups});
    }

    uploadPlanogram(){
        let strippedShelfGroups = this.stripProductDetailsFromPlanogram();
        if(strippedShelfGroups.isValid){
            this.toggleDetailsModal();
        }

        this.setState({isValid: strippedShelfGroups.isValid});
    }

    stripProductDetailsFromPlanogram(){
        var noItemsCount = 0;
        var shelvesCount = 0;
        let shelfGroups =  JSON.parse(JSON.stringify(this.state.shelfGroups));
        for(let shelfGroup of shelfGroups){
            for(let shelf of shelfGroup.shelves){
                shelvesCount ++;
                if(shelf.items != undefined){
                    shelf.items = shelf.items.map((product) => { 
                        let item = {};
                        item[product.id] = true;
                        return item;
                    });
                } else {
                    noItemsCount++;
                }
            }
        }

        return {
            shelfGroups: shelfGroups,
            isValid: noItemsCount != shelvesCount
        };
    }

    toggleDetailsModal(){
        this.setState({detailsModal: !this.state.detailsModal});
    }

    saveDetails(details){
        let strippedShelfGroups = this.stripProductDetailsFromPlanogram();

        let planogram = {
            name: details.name,
            image: details.icon,
            segmentIDs: details.segmentIds,
            equipmentID: this.props.match.params.equipmentId
        };
        
        planogram['shelf-groups'] = strippedShelfGroups.shelfGroups;
        this.props.uploadPlanogram(planogram);

        this.props.history.push('/equipment/' + this.props.match.params.equipmentId);
    }

    addProductsToShelf(){

        let productsToAdd = [];
        for (let i = 0; i < this.state.sliderValue; i++){
            productsToAdd.push(Object.assign({}, this.state.selectedProduct));
        }

        let updatedShelf = Object.assign({}, this.state.selectedShelf);

        if(updatedShelf.items == undefined){
            updatedShelf.items = productsToAdd;
        } else {
            updatedShelf.items = [...updatedShelf.items, ...productsToAdd];
        }

        this.updateShelf(updatedShelf);

        this.setState({
            showSlider: false,
            selectedShelf: {}
        });
        
        this.deselectProduct();
    }

    updateShelf(updatedShelf){
        let shelfgroups =  JSON.parse(JSON.stringify(this.state.shelfGroups));

        for(let shelfGroup of shelfgroups){
            for(let shelf of shelfGroup.shelves){
                if(shelf.order == updatedShelf.order){
                    shelf.items = updatedShelf.items;
                }
            }
        }
        this.updateShelfGroups(shelfgroups);
    }

    render() {
        return (
            <Fragment>
                <div className="page-title">Planogram Creator</div>
                <div className="planogram-page-container">
                    <PlanogramDetailsModal isOpen={this.state.detailsModal} toggleModal={this.toggleDetailsModal} saveDetails={this.saveDetails}/>
                    {(this.props.fetchingEquipmentItem || this.props.fetchingProducts) && 
                        <Loading/>
                    }
                    
                    {this.props.fetchedEquipmentItem && this.props.fetchedProducts &&
                        <div className='planogram-creator-container'>

                            <div className='planogram-customiser-container'>
                                <div className="planogram-products-container vision-card">
                                    <div className="vision-card-title">Products</div>   
                                    <div className="planogram-products-list">
                                        {this.state.products.map((product) => {
                                            return(<PlanogramProduct key={product.id} product={product} id={product.id} isSelected={this.state.selectedProduct == product} productSelected={this.productSelected}/>);
                                        })}
                                    </div>
                                </div>
                                
                                <div className="planogram-shelf-groups-container ">
                                    <div className="planogram-shelve-container vision-card">
                                        <div className="vision-card-title">Shelves</div>   
                                        <PlanogramItem availableSlotsUpdated={this.availableSlotsUpdated} shelfSelected={this.shelfSelected} selectedShelf={this.state.selectedShelf} shelfGroups={this.state.shelfGroups} selectedProduct={this.state.selectedProduct} deselectProduct={this.deselectProduct} updateShelfGroups={this.updateShelfGroups}/>
                                    </div>

                                    {this.state.showSlider &&
                                        <div className="vision-card noselect">
                                            <div className="product-slider-container">
                                                <FormText className="noselect">Adjust the slider to fill the selected shelf</FormText>
                                                <Slider min={this.state.sliderMin} max={this.state.sliderMax} onChange={this.sliderSelectionChanged}/>
                                                
                                                <div className="slider-bottom-controls">
                                                    <div className="product-slider-buttons">
                                                        <Button className="button" onClick={this.deselectProduct}>Cancel</Button>
                                                        <Button className="button" color="primary" onClick={this.addProductsToShelf}>Add</Button>
                                                    </div>
                                                    <div className="slider-value-label">
                                                        <Label >{this.state.sliderValue}</Label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="creation-button-group">
                                        <FormGroup>
                                            <Button className="create-planogram-button button" color="primary" onClick={this.uploadPlanogram}>Create</Button>
                                        </FormGroup>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    }
                </div>
            </Fragment>
        );
    }
}

PlanogramCreationPage.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    equipmentItem: PropTypes.object.isRequired,
    products: PropTypes.array.isRequired,
    getEquipmentItem: PropTypes.func.isRequired,
    getProducts: PropTypes.func.isRequired,
    fetchingEquipmentItem: PropTypes.bool.isRequired,
    fetchedEquipmentItem: PropTypes.bool.isRequired,
    failedEquipmentItem: PropTypes.bool.isRequired,
    fetchingProducts: PropTypes.bool.isRequired,
    fetchedProducts: PropTypes.bool.isRequired,
    failedProducts: PropTypes.bool.isRequired,
    uploadPlanogram: PropTypes.func.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { equipmentItem, fetchingEquipmentItem, fetchedEquipmentItem, failedEquipmentItem } = state.equipmentReducer;
    const { products, fetchingProducts, fetchedProducts, failedProducts } = state.productReducer;
    return { equipmentItem, fetchingEquipmentItem, fetchedEquipmentItem, failedEquipmentItem, products, fetchingProducts, fetchedProducts, failedProducts };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getEquipmentItem, getProducts, uploadPlanogram }, dispatch)
);

// CONFIGURE REACT REDUX

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(PlanogramCreationPage));

// EXPORT COMPONENT

export { hoc as PlanogramCreationPage };


// WEBPACK FOOTER //
// ./src/components/pages/Planograms/PlanogramCreationPage.js